import React from 'react';
import { useTranslation } from 'next-i18next';
import {
  Typography, Grid, Box, Container,
} from '@mui/material';
// import { RegistrationAside } from 'views/user-module/common/components/UI/RegistrationAside/RegistrationAside';
import StyledBox from 'views/user-module/common/components/UI/SigningPages/SigningPages.styles';
import { TabsBar } from 'views/common/components/UI/TabsBar/TabsBar';
import { ImgBox } from 'views/common/components';
import { AppAdLinks } from 'views/common/components/UI/AppAdLinks/AppAdLinks';

import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';

const StyledRewardsItemsList = dynamic(() => import(
  'views/user-module/common/components/UI/SigningPages/SigningPages.styles'
).then((file) => file.StyledRewardsItemsList));

const SigningPages = (props) => {
  const { t } = useTranslation('fe_er_sign_up_page');
  const {
    children,
    title,
    selectedTab,
    handleTabClick,
    // hideWhyEagleriderSection,
    hideTabs,
  } = props;

  const tabs = [
    {
      label: t('fe_er_sign_up_page:sign_in'),
      value: 1,
    },
    {
      label: t('fe_er_sign_up_page:sign_up'),
      value: 2,
    },
  ];
  const { appState } = useSelector((state) => state.globalData);

  return (
    <StyledBox>
      <Container maxWidth="xl">
        <Grid container columnSpacing={9}>
          <Grid
            item
            lg={5}
            md={12}
            sm={12}
            order={{ xs: 2, md: 2, lg: 1 }}
            className="SPCustomGrid ">
            <Box className="SPBg">
              <Box className="SPBannerContainer">
                <Box className="SPBanner">
                  <ImgBox
                    image={{
                      src: '/imgs/sign-banner.png',
                      alt: 'ER-Banner',
                    }}
                    imgWidth="100%"
                    imgHeight="100%"
                  />
                </Box>
                <Box className="SPBannerFooter">
                  <AppAdLinks />
                  <Box className="SPBannerFooterrBG">
                    <ImgBox
                      image={{
                        src: '/imgs/AppAdBG.png',
                        alt: 'Ad-BG',
                      }}
                      imgHeight="100%"
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            {appState?.settings?.rewards_program_enabled && (
              <Box className="SPRegistrationAside">
                <StyledRewardsItemsList swichLogoAtDifScreen />
              </Box>
            )}

            {/* {!hideWhyEagleriderSection && (
              <Box className="SPRegistrationAside">
                <RegistrationAside />
              </Box>
            )} */}
          </Grid>
          <Grid item lg={7} md={12} sm={12} order={{ xs: 1, md: 1, lg: 2 }}>
            <Box py={3} className="SUVFormContainer">
              {!hideTabs && (
                <Box mb={2}>
                  <TabsBar
                    tabs={tabs}
                    selectedTab={selectedTab}
                    handleTabClick={handleTabClick}
                  />
                </Box>
              )}

              <Typography variant="h3" component="h3">
                {title}
              </Typography>
              {children}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { SigningPages };
